import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetSeasonStyle0 = gravityIconIndividualCss;

const GravityIconAssetSeason = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'f0ba99399f96ce3ab9b49e9a90c5c1bdfba293f5', color: this.color, size: this.size }, h("svg", { key: 'ec21339d48f45a9e863ef0e35aaceef49925bb40', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'aeb51cd6731bf6de0681de4492bbf72e5560b949', d: "M6 13.32V8.68a.2.2 0 0 1 .31-.17l4.14 2.32a.21.21 0 0 1 0 .34L6.3 13.49a.2.2 0 0 1-.3-.17Z", fill: "currentColor" }), h("path", { key: 'd56baecfa1aa9c838692d6caa6ad36490b64e63a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.51 5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5h-11Zm.99 1.5h9v9h-9v-9Z", fill: "currentColor" }), h("path", { key: '998c6161d3340e3f091986ea5f09fd874671bf49', d: "M15.99 6.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5h-.5ZM18.48 8a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V8Z", fill: "currentColor" }))));
    }
};
GravityIconAssetSeason.style = GravityIconAssetSeasonStyle0;

export { GravityIconAssetSeason as gravity_icon_asset_season };

//# sourceMappingURL=gravity-icon-asset-season.entry.js.map